module.exports = __webpack_public_path__ + "img/perell-logo.8bbaf04f.jpg";